import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { projectSchema } from "./project";

export const quantitySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  projectId: projectSchema.shape.id,
  createdAt: z.coerce.date().default(new Date()),
  updatedAt: z.coerce.date().default(new Date()),
});

export const newQuantityInputSchema = quantitySchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const editQuantityInputSchema = quantitySchema.pick({
  name: true,
});

export type Quantity = z.infer<typeof quantitySchema>;
export type QuantityInput = z.input<typeof quantitySchema>;
export type NewQuantityInput = z.input<typeof newQuantityInputSchema>;

export const createQuantity = (input: NewQuantityInput): Quantity => {
  return newQuantity({
    ...input,
    id: uuidv7(),
  });
};

export const newQuantity = (input: QuantityInput): Quantity => quantitySchema.parse(input);
